
interface PropertyHostProps {
  host?: {
    name: string;
    avatar: string;
    superHost: boolean;
    experience: string;
  };
}

const PropertyHost = ({ host }: PropertyHostProps) => {
  if (!host) {
    return null;
  }

  return (
    <div className="flex items-center space-x-4 mb-8 py-6 border-b border-gray-200">
      <div className="relative">
        <img 
          src={host.avatar} 
          alt={`Anfitrión ${host.name}`} 
          className="w-12 h-12 rounded-full object-cover" 
        />
      </div>
      <div>
        <h3 className="font-semibold text-gray-900">
          Anfitrión: {host.name}
        </h3>
        <p className="text-gray-600 text-sm">
          {host.superHost ? 'SuperAnfitrión' : 'Anfitrión'} · {host.experience}
        </p>
      </div>
    </div>
  );
};

export default PropertyHost;
